import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Docs18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M2.23717 1.28849L8 3.20943L13.7628 1.28849C14.2405 1.12928 14.75 1.49653 14.75 2V5C14.75 5.41422 14.4142 5.75 14 5.75C13.5858 5.75 13.25 5.41422 13.25 5V3.04057L8.23717 4.71151C8.08322 4.76283 7.91678 4.76283 7.76283 4.71151L2.75 3.04057V11.9594L8.23717 13.7885C8.63013 13.9195 8.8425 14.3442 8.71151 14.7372C8.58053 15.1301 8.15579 15.3425 7.76283 15.2115L1.76283 13.2115C1.45657 13.1094 1.25 12.8228 1.25 12.5V2C1.25 1.49653 1.75953 1.12928 2.23717 1.28849Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.75 10.5C7.75 8.15279 9.65279 6.25 12 6.25C14.3472 6.25 16.25 8.15279 16.25 10.5C16.25 11.5308 15.883 12.4759 15.2725 13.2118L17.0304 14.9697L15.9697 16.0303L14.1224 14.183C13.4978 14.5436 12.773 14.75 12 14.75C9.65279 14.75 7.75 12.8472 7.75 10.5ZM12 7.75C10.4812 7.75 9.25 8.98121 9.25 10.5C9.25 12.0188 10.4812 13.25 12 13.25C13.5188 13.25 14.75 12.0188 14.75 10.5C14.75 8.98121 13.5188 7.75 12 7.75Z'
      fill='currentColor'
    />
  </Svg>
);

Docs18.displayName = 'Docs18';
export default Docs18;
